import { useLocation } from "react-router-dom";
export const Redirect = () => {
    const query = new URLSearchParams(useLocation().search);

    const hash = query.get('hash')

    if (!hash) return <></>
    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <p>Please install the android app and retry the link</p>
            </div>
        </>
    )
}